
export default "/assets/viewfinder.40396210.svg"